// ISO 3166-1 alpha-2 -> major cities (starter set)
export const COUNTRY_CITIES: Record<string, string[]> = {
    // --- Europe
    DE: ["Berlin","Hamburg","Munich","Cologne","Frankfurt","Stuttgart","Düsseldorf","Dortmund","Essen","Leipzig"],
    FR: ["Paris","Marseille","Lyon","Toulouse","Nice","Nantes","Strasbourg","Montpellier","Bordeaux","Lille"],
    IT: ["Rome","Milan","Naples","Turin","Palermo","Genoa","Bologna","Florence","Bari","Catania"],
    ES: ["Madrid","Barcelona","Valencia","Seville","Zaragoza","Málaga","Murcia","Palma","Bilbao","Alicante"],
    GB: ["London","Birmingham","Manchester","Glasgow","Liverpool","Leeds","Sheffield","Bristol","Edinburgh","Cardiff"],
    NL: ["Amsterdam","Rotterdam","The Hague","Utrecht","Eindhoven","Tilburg","Groningen","Almere","Breda","Nijmegen"],
    BE: ["Brussels","Antwerp","Ghent","Charleroi","Liège","Bruges","Namur","Leuven","Mons","Mechelen"],
    CH: ["Zurich","Geneva","Basel","Lausanne","Bern","Winterthur","Lucerne","St. Gallen","Lugano","Biel/Bienne"],
    AT: ["Vienna","Graz","Linz","Salzburg","Innsbruck","Klagenfurt","Villach","Wels","Sankt Pölten","Dornbirn"],
    PL: ["Warsaw","Kraków","Łódź","Wrocław","Poznań","Gdańsk","Szczecin","Bydgoszcz","Lublin","Katowice"],
    SE: ["Stockholm","Gothenburg","Malmö","Uppsala","Västerås","Örebro","Linköping","Helsingborg","Jönköping","Norrköping"],
    NO: ["Oslo","Bergen","Trondheim","Stavanger","Drammen","Fredrikstad","Kristiansand","Sandnes","Tromsø","Sarpsborg"],
    DK: ["Copenhagen","Aarhus","Odense","Aalborg","Esbjerg","Randers","Kolding","Horsens","Vejle","Roskilde"],
    FI: ["Helsinki","Espoo","Tampere","Vantaa","Oulu","Turku","Jyväskylä","Lahti","Kuopio","Pori"],
    IE: ["Dublin","Cork","Limerick","Galway","Waterford","Drogheda","Dundalk","Swords","Bray","Navan"],
    PT: ["Lisbon","Porto","Vila Nova de Gaia","Braga","Coimbra","Funchal","Setúbal","Aveiro","Leiria","Faro"],
    GR: ["Athens","Thessaloniki","Patras","Heraklion","Larissa","Volos","Rhodes","Ioannina","Chania","Kavala"],
    HU: ["Budapest","Debrecen","Szeged","Miskolc","Pécs","Győr","Nyíregyháza","Kecskemét","Székesfehérvár","Szombathely"],
    CZ: ["Prague","Brno","Ostrava","Plzeň","Liberec","Olomouc","České Budějovice","Hradec Králové","Ústí nad Labem","Pardubice"],
    RO: ["Bucharest","Cluj-Napoca","Timișoara","Iași","Constanța","Craiova","Brașov","Galați","Ploiești","Oradea"],
    UA: ["Kyiv","Kharkiv","Odesa","Dnipro","Lviv","Zaporizhzhia","Kryvyi Rih","Mykolaiv","Mariupol","Vinnytsia"],
    TR: ["Istanbul","Ankara","Izmir","Bursa","Adana","Gaziantep","Konya","Antalya","Kayseri","Mersin"],
    IS: ["Reykjavík","Kópavogur","Hafnarfjörður","Akureyri","Reykjanesbær","Garðabær","Mosfellsbær","Árborg","Akranes","Selfoss"],
    EE: ["Tallinn","Tartu","Narva","Pärnu","Kohtla-Järve","Viljandi","Rakvere","Maardu","Sillamäe","Kuressaare"],
    LV: ["Riga","Daugavpils","Liepāja","Jelgava","Jūrmala","Ventspils","Rēzekne","Valmiera","Ogre","Cēsis"],
    LT: ["Vilnius","Kaunas","Klaipėda","Šiauliai","Panevėžys","Alytus","Marijampolė","Mažeikiai","Jonava","Utena"],
    SI: ["Ljubljana","Maribor","Celje","Kranj","Velenje","Koper","Novo Mesto","Ptuj","Trbovlje","Kamnik"],
    SK: ["Bratislava","Košice","Prešov","Žilina","Nitra","Banská Bystrica","Trnava","Trenčín","Martin","Poprad"],
    HR: ["Zagreb","Split","Rijeka","Osijek","Zadar","Slavonski Brod","Pula","Karlovac","Varaždin","Šibenik"],
    RS: ["Belgrade","Novi Sad","Niš","Kragujevac","Subotica","Zrenjanin","Pančevo","Čačak","Kraljevo","Šabac"],
    BA: ["Sarajevo","Banja Luka","Tuzla","Zenica","Mostar","Bijeljina","Brčko","Prijedor","Doboj","Cazin"],
    ME: ["Podgorica","Nikšić","Herceg Novi","Pljevlja","Bar","Bijelo Polje","Cetinje","Budva","Berane","Ulcinj"],
    MK: ["Skopje","Bitola","Kumanovo","Prilep","Tetovo","Veles","Štip","Ohrid","Gostivar","Strumica"],
    AL: ["Tirana","Durrës","Vlorë","Shkodër","Fier","Korçë","Elbasan","Berat","Lushnjë","Pogradec"],
    XK: ["Pristina","Prizren","Peja","Gjakova","Mitrovica","Gjilan","Ferizaj","Vushtrri","Podujevo","Suharekë"],
    BG: ["Sofia","Plovdiv","Varna","Burgas","Ruse","Stara Zagora","Pleven","Sliven","Dobrich","Shumen"],
    MD: ["Chișinău","Tiraspol","Bălți","Bender","Rîbnița","Cahul","Ungheni","Soroca","Orhei","Comrat"],
    LU: ["Luxembourg","Esch-sur-Alzette","Differdange","Dudelange","Ettelbruck","Diekirch","Wiltz","Echternach","Grevenmacher","Remich"],
    LI: ["Vaduz","Schaan","Balzers","Triesen","Eschen","Mauren","Triesenberg","Ruggell","Gamprin","Schellenberg"],
    MT: ["Valletta","Birkirkara","Mosta","Qormi","Żabbar","San Ġwann","Naxxar","Sliema","Paola","Rabat"],
    CY: ["Nicosia","Limassol","Larnaca","Famagusta","Paphos","Kyrenia","Morphou","Aradippou","Paralimni","Ayia Napa"],
    SM: ["San Marino","Serravalle","Borgo Maggiore","Domagnano","Fiorentino","Acquaviva","Chiesanuova","Faetano","Montegiardino"],
    VA: ["Vatican City"],
    AD: ["Andorra la Vella","Escaldes-Engordany","Encamp","Sant Julià de Lòria","La Massana","Ordino","Canillo"],
    MC: ["Monaco","Monte Carlo","La Condamine","Fontvieille"],
  
    CA: ["Toronto","Montreal","Vancouver","Calgary","Edmonton","Ottawa","Winnipeg","Quebec City","Hamilton","Kitchener"],
    MX: ["Mexico City","Guadalajara","Monterrey","Puebla","Tijuana","León","Ciudad Juárez","Zapopan","Mérida","San Luis Potosí"],
  // --- Central America ---
    BZ: ["Belize City","Belmopan","San Ignacio","Orange Walk Town","Corozal Town","Dangriga","Punta Gorda","Benque Viejo del Carmen","San Pedro", "Placencia",],
    CR: ["San José","Alajuela","Cartago","Heredia","Puntarenas","Limón","San Carlos","Liberia","Parrita","Grecia", "Paraíso"],
    DO: ["Santo Domingo","Santiago de los Caballeros","Santo Domingo Este","San Pedro de Macorís","La Romana","San Francisco de Macorís","San Cristóbal","Puerto Plata","La Vega","Boca Chica"],
    SV: ["San Salvador","Santa Ana","San Miguel","Soyapango","Santa Tecla","Mejicanos","Apopa","Delgado","Ilopango", "Ahuachapán",],
    GT: ["Guatemala City", "Mixco", "Villa Nueva", "Quetzaltenango","Escuintla","Petapa","San Juan Sacatepéquez","Chimaltenango","Amatitlán", "Puerto Barrios",],
    HN: ["Tegucigalpa", "San Pedro Sula", "Choloma", "La Ceiba", "El Progreso", "Choluteca","Comayagua", "Puerto Cortés","Danlí","Villanueva",],
    NI: ["Managua","León","Masaya","Chinandega","Matagalpa","Estelí","Granada","Jinotega","Bluefields","Rivas",],
    PA: ["Panama City","San Miguelito","Tocumen","David","Colón","Arraiján","La Chorrera","Santiago","Chitré", "Penonomé",],
  
    // --- South America
    BR: ["São Paulo","Rio de Janeiro","Brasília","Salvador","Fortaleza","Belo Horizonte","Manaus","Curitiba","Recife","Porto Alegre"],
    AR: ["Buenos Aires","Córdoba","Rosario","Mendoza","La Plata","San Miguel de Tucumán","Mar del Plata","Salta","Santa Fe","San Juan"],
    CL: ["Santiago","Puente Alto","Antofagasta","Viña del Mar","Valparaíso","Talcahuano","Temuco","Iquique","Rancagua","La Serena"],
    CO: ["Bogotá","Medellín","Cali","Barranquilla","Cartagena","Cúcuta","Bucaramanga","Pereira","Santa Marta","Ibagué"],
    PE: ["Lima","Arequipa","Trujillo","Chiclayo","Piura","Iquitos","Cusco","Chimbote","Huancayo","Tacna"],
    UY: ["Montevideo","Salto","Paysandú","Las Piedras","Rivera","Maldonado","Tacuarembó","Melo","Mercedes","Artigas"],
    PY: ["Asunción","Ciudad del Este","San Lorenzo","Luque","Capiatá","Lambaré","Fernando de la Mora","Encarnación","Pedro Juan Caballero","Coronel Oviedo"],  
    BO: ["Santa Cruz de la Sierra","La Paz","El Alto","Cochabamba","Sucre","Oruro","Potosí","Tarija","Montero","Trinidad"], 
    EC: ["Quito","Guayaquil","Cuenca","Santo Domingo","Machala","Manta","Portoviejo","Ambato","Riobamba","Ibarra"], 
    VE: ["Caracas","Maracaibo","Valencia","Barquisimeto","Maracay","Ciudad Guayana","Barcelona","Maturín","San Cristóbal","Cumaná"],  
    GY: ["Georgetown","Linden","New Amsterdam","Bartica","Skeldon","Rosignol","Anna Regina","Lethem","Mahdia","Vreed-en-Hoop"],
    SR: ["Paramaribo","Lelydorp","Nieuw Nickerie","Moengo","Nieuw Amsterdam","Albina","Brokopondo","Groningen","Onverwacht","Totness"],
    
    // --- Asia
    IN: ["Mumbai","Delhi","Bengaluru","Hyderabad","Ahmedabad","Chennai","Kolkata","Surat","Pune","Jaipur"],
    JP: ["Tokyo","Yokohama","Osaka","Nagoya","Sapporo","Fukuoka","Kobe","Kyoto","Kawasaki","Saitama"],
    KR: ["Seoul","Busan","Incheon","Daegu","Daejeon","Gwangju","Suwon","Ulsan","Changwon","Seongnam"],
    ID: ["Jakarta","Surabaya","Bandung","Medan","Bekasi","Depok","Tangerang","Semarang","Palembang","Makassar"],
    PH: ["Quezon City","Manila","Davao City","Caloocan","Cebu City","Zamboanga City","Taguig","Antipolo","Pasig","Cagayan de Oro"],
    AE: ["Dubai","Abu Dhabi","Sharjah","Al Ain","Ajman","Ras Al Khaimah","Fujairah","Umm Al Quwain","Khor Fakkan","Dibba Al-Fujairah"],
    CN: ["Shanghai","Beijing","Guangzhou","Shenzhen","Chengdu","Chongqing","Wuhan","Hangzhou","Nanjing","Xi'an"],
    TH: ["Bangkok","Chiang Mai","Phuket","Pattaya","Hat Yai","Nakhon Ratchasima","Udon Thani","Khon Kaen","Surat Thani","Rayong"],
    VN: ["Ho Chi Minh City","Hanoi","Da Nang","Hai Phong","Can Tho","Bien Hoa","Hue","Vung Tau","Nha Trang","Buon Ma Thuot"],
    MY: ["Kuala Lumpur","George Town","Johor Bahru","Ipoh","Shah Alam","Petaling Jaya","Seremban","Melaka","Alor Setar","Kota Bharu"],
    SG: ["Singapore"],
    PK: ["Karachi","Lahore","Faisalabad","Rawalpindi","Gujranwala","Multan","Hyderabad","Islamabad","Quetta","Peshawar"],
    BD: ["Dhaka","Chittagong","Khulna","Rajshahi","Sylhet","Barisal","Rangpur","Mymensingh","Cumilla","Narayanganj"],
    LK: ["Colombo","Dehiwala-Mount Lavinia","Moratuwa","Sri Jayawardenepura Kotte","Negombo","Kandy","Galle","Jaffna","Trincomalee","Batticaloa"],
    NP: ["Kathmandu","Pokhara","Lalitpur","Bharatpur","Biratnagar","Birgunj","Butwal","Dharan","Hetauda","Janakpur"],
    MM: ["Yangon","Mandalay","Naypyidaw","Bago","Pathein","Mawlamyine","Taunggyi","Monywa","Myitkyina","Sittwe"],
    KH: ["Phnom Penh","Siem Reap","Battambang","Poipet","Sihanoukville","Kampong Cham","Takeo","Kampot","Pursat","Svay Rieng"],
    LA: ["Vientiane","Savannakhet","Pakse","Luang Prabang","Thakhek","Xam Neua","Phonsavan","Muang Xay","Champasak","Attapeu"],
    MN: ["Ulaanbaatar","Erdenet","Darkhan","Choibalsan","Mörön","Ölgii","Sükhbaatar","Bayankhongor","Arvaikheer","Zuunmod"],
    KZ: ["Almaty","Astana","Shymkent","Karaganda","Aktobe","Taraz","Pavlodar","Ust-Kamenogorsk","Kyzylorda","Atyrau"],
    UZ: ["Tashkent","Samarkand","Bukhara","Namangan","Andijan","Fergana","Nukus","Karshi","Kokand","Margilan"],
    IR: ["Tehran","Mashhad","Isfahan","Karaj","Shiraz","Tabriz","Qom","Ahvaz","Kermanshah","Urmia"],
    IQ: ["Baghdad","Basra","Mosul","Erbil","Sulaymaniyah","Kirkuk","Najaf","Karbala","Ramadi","Fallujah"],
    IL: ["Jerusalem","Tel Aviv","Haifa","Rishon LeZion","Petah Tikva","Ashdod","Netanya","Beersheba","Holon","Bnei Brak"],
    JO: ["Amman","Zarqa","Irbid","Aqaba","Madaba","As-Salt","Jerash","Mafraq","Karak","Tafilah"],
    SA: ["Riyadh","Jeddah","Mecca","Medina","Dammam","Khobar","Dhahran","Taif","Abha","Jazan"],
    QA: ["Doha","Al Rayyan","Al Wakrah","Umm Salal","Al Khor","Dukhan","Mesaieed","Lusail","Al Shamal","Al Daayen"],
    KW: ["Kuwait City","Hawally","Salmiya","Farwaniya","Jahra","Ahmadi","Mangaf","Sabah Al Salem","Fahaheel","Abu Halifa"],
    OM: ["Muscat","Seeb","Salalah","Sohar","Nizwa","Sur","Ibri","Buraimi","Rustaq","Khasab"],
    YE: ["Sana'a","Aden","Taiz","Al Hudaydah","Ibb","Dhamar","Mukalla","Zinjibar","Amran","Sa'dah"],

    // --- Africa
    ZA: ["Johannesburg","Cape Town","Durban","Pretoria","Port Elizabeth","Bloemfontein","Nelspruit","Polokwane","Kimberley","East London"],
    NG: ["Lagos","Kano","Ibadan","Abuja","Port Harcourt","Benin City","Kaduna","Jos","Ilorin","Enugu"],
    KE: ["Nairobi","Mombasa","Kisumu","Nakuru","Eldoret","Thika","Malindi","Kitale","Garissa","Kakamega"],
    EG: ["Cairo","Alexandria","Giza","Shubra El Kheima","Port Said","Suez","Luxor","Mansoura","Tanta","Asyut"],
    MA: ["Casablanca","Rabat","Fes","Marrakesh","Tangier","Agadir","Meknes","Oujda","Kenitra","Tetouan"],
    DZ: ["Algiers","Oran","Constantine","Annaba","Blida","Batna","Sétif","Sidi Bel Abbès","Biskra","Tébessa"],
    TN: ["Tunis","Sfax","Sousse","Ettadhamen","Kairouan","Gabès","Bizerte","Ariana","Gafsa","Ben Arous"],
    LY: ["Tripoli","Benghazi","Misrata","Zawiya","Zliten","Ajdabiya","Tobruk","Sabha","Derna","Sirte"],
    SD: ["Khartoum","Omdurman","Bahri","Port Sudan","Kassala","El Obeid","Nyala","Kosti","Wad Madani","Dongola"],
    ET: ["Addis Ababa","Dire Dawa","Mekelle","Gondar","Bahir Dar","Hawassa","Jimma","Jijiga","Shashamane","Adama"],
    TZ: ["Dar es Salaam","Dodoma","Mwanza","Arusha","Mbeya","Morogoro","Tanga","Kigoma","Moshi","Tabora"],
    UG: ["Kampala","Gulu","Lira","Mbarara","Jinja","Entebbe","Masaka","Arua","Mbale","Fort Portal"],
    RW: ["Kigali","Butare","Gitarama","Musanze","Rubavu","Nyagatare","Rwamagana","Kibuye","Byumba","Cyangugu"],
    BI: ["Bujumbura","Gitega","Ngozi","Ruyigi","Muyinga","Rumonge","Bururi","Makamba","Muramvya","Cibitoke"],
    CM: ["Douala","Yaoundé","Garoua","Bamenda","Maroua","Ngaoundéré","Bafoussam","Nkongsamba","Ebolowa","Limbé"],
    GH: ["Accra","Kumasi","Tamale","Takoradi","Cape Coast","Sunyani","Koforidua","Ho","Wa","Bolgatanga"],
    CI: ["Abidjan","Bouaké","Daloa","Yamoussoukro","San-Pédro","Korhogo","Man","Divo","Gagnoa","Abengourou"],
    SN: ["Dakar","Pikine","Guédiawaye","Rufisque","Thiès","Kaolack","Saint-Louis","Ziguinchor","Touba","Mbour"],
    ML: ["Bamako","Sikasso","Mopti","Ségou","Kayes","Koutiala","Gao","Tombouctou","San","Markala"],
    BF: ["Ouagadougou","Bobo-Dioulasso","Koudougou","Banfora","Ouahigouya","Kaya","Tenkodogo","Fada N’Gourma","Dédougou","Houndé"],
    NE: ["Niamey","Zinder","Maradi","Agadez","Tahoua","Dosso","Diffa","Tillabéri","Arlit","Birni-N’Konni"],
    ZW: ["Harare","Bulawayo","Chitungwiza","Mutare","Gweru","Kwekwe","Kadoma","Masvingo","Chinhoyi","Victoria Falls"],
    ZM: ["Lusaka","Ndola","Kitwe","Kabwe","Chingola","Mufulira","Livingstone","Kasama","Solwezi","Chipata"],
    BW: ["Gaborone","Francistown","Molepolole","Serowe","Maun","Kanye","Mahalapye","Palapye","Mochudi","Lobatse"],
    NA: ["Windhoek","Walvis Bay","Swakopmund","Oshakati","Rundu","Katima Mulilo","Rehoboth","Otjiwarongo","Grootfontein","Keetmanshoop"],
    AO: ["Luanda","Huambo","Lobito","Benguela","Lubango","Malanje","Soyo","Cabinda","Uíge","Menongue"],
    MZ: ["Maputo","Matola","Beira","Nampula","Chimoio","Nacala","Quelimane","Tete","Pemba","Xai-Xai"],
    MG: ["Antananarivo","Toamasina","Antsirabe","Mahajanga","Fianarantsoa","Toliara","Antsiranana","Ambovombe","Manakara","Morondava"],
    MW: ["Lilongwe","Blantyre","Mzuzu","Zomba","Kasungu","Mangochi","Salima","Karonga","Nkhotakota","Balaka"],
    LS: ["Maseru","Teyateyaneng","Mafeteng","Hlotse","Mohale’s Hoek","Qacha’s Nek","Quthing","Butha-Buthe","Maputsoe","Roma"],
    SZ: ["Mbabane","Manzini","Big Bend","Mhlume","Siteki","Nhlangano","Piggs Peak","Lavumisa","Hlathikhulu","Kwaluseni"],

    // --- Oceania
    AU: ["Sydney","Melbourne","Brisbane","Perth","Adelaide","Gold Coast","Canberra","Newcastle","Wollongong","Hobart"],
    NZ: ["Auckland","Wellington","Christchurch","Hamilton","Tauranga","Dunedin","Palmerston North","Napier","Nelson","Rotorua"],
    PG: ["Port Moresby","Lae","Mount Hagen","Madang","Goroka","Kokopo","Kimbe","Alotau","Vanimo","Wewak"],
    FJ: ["Suva","Nadi","Lautoka","Labasa","Ba","Levuka","Sigatoka","Nausori","Rakiraki","Savusavu"],
    SB: ["Honiara","Gizo","Auki","Munda","Buala","Tulagi","Kirakira","Taro Island","Lata","Noro"],
    VU: ["Port Vila","Luganville","Norsup","Lakatoro","Isangel","Sola","Lenakel","Longana","Port Olry","Bunlap"],
    WS: ["Apia","Vaitele","Faleula","Siusega","Malie","Safotu","Leulumoega","Lalomanu","Mulifanua","Satapuala"],
    TO: ["Nukuʻalofa","Neiafu","Haveluloto","Vaini","Pangai","Houma","Kolovai","Lapaha","Ohonua","Hihifo"],
    KI: ["South Tarawa","Betio","Bairiki","Teaoraereke","Eita","Bonriki","Tabwakea","Temwaiku","Abaiang","Butaritari"],
    TV: ["Funafuti","Vaiaku","Fongafale","Asau","Tanrake","Toga","Nanumea","Nanumaga","Niutao","Nui"],
    NR: ["Yaren","Anabar","Anibare","Aiwo","Boe","Buada","Denigomodu","Ewa","Ijuw","Meneng"],
    FM: ["Palikir","Kolonia","Weno","Tofol","Colonia","Nanpei","Sapwuahfik","Utwe","Lele","Malem"],
    MH: ["Majuro","Ebeye","Jaluit","Wotje","Arno","Likiep","Ailuk","Aur","Mili","Ebon"],
    PW: ["Ngerulmud","Koror","Melekeok","Airai","Ngaraard","Ngardmau","Ngchesar","Ngatpang","Aimeliik","Peleliu"],
 };
  
  export const COUNTRY_STATE_CITIES: Record<string, Record<string, string[]>> = {
    US: {
      Alabama: [
        "Birmingham","Montgomery","Mobile","Huntsville","Tuscaloosa","Hoover","Dothan","Auburn","Decatur","Madison"
      ],
      Alaska: [
        "Anchorage","Fairbanks","Juneau","Sitka","Ketchikan","Wasilla","Kenai","Kodiak","Bethel","Palmer"
      ],
      Arizona: [
        "Phoenix","Tucson","Mesa","Chandler","Scottsdale","Glendale","Tempe","Peoria","Surprise","Yuma"
      ],
      Arkansas: [
        "Little Rock","Fort Smith","Fayetteville","Springdale","Jonesboro","Rogers","Conway","Bentonville","Hot Springs","Pine Bluff"
      ],
      California: [
        "Los Angeles","San Diego","San Jose","San Francisco","Oakland","Sacramento","Fresno","Long Beach","Anaheim","Santa Ana",
        "Riverside","Stockton","Irvine","Chula Vista","Fremont","San Bernardino","Modesto","Oxnard","Fontana","Moreno Valley"
      ],
      Colorado: [
        "Denver","Colorado Springs","Aurora","Fort Collins","Lakewood","Thornton","Arvada","Westminster","Pueblo","Greeley"
      ],
      Connecticut: [
        "Bridgeport","New Haven","Stamford","Hartford","Waterbury","Norwalk","Danbury","New Britain","Bristol","West Hartford"
      ],
      Delaware: [
        "Wilmington","Dover","Newark","Middletown","Smyrna","Milford","Seaford","Georgetown","Elsmere","New Castle"
      ],
      Florida: [
        "Jacksonville","Miami","Tampa","Orlando","St. Petersburg","Hialeah","Tallahassee","Fort Lauderdale","Port St. Lucie","Cape Coral",
        "Gainesville","Sarasota","Clearwater","Palm Bay","Coral Springs"
      ],
      Georgia: [
        "Atlanta","Augusta","Columbus","Macon","Savannah","Athens","Sandy Springs","Roswell","Johns Creek","Albany"
      ],
      Hawaii: [
        "Honolulu","Hilo","Kailua","Kapolei","Kaneohe","Waipahu","Pearl City","Mililani Town","Kahului","Lahaina"
      ],
      Idaho: [
        "Boise","Meridian","Nampa","Idaho Falls","Pocatello","Caldwell","Coeur d’Alene","Twin Falls","Lewiston","Rexburg"
      ],
      Illinois: [
        "Chicago","Aurora","Naperville","Joliet","Rockford","Springfield","Elgin","Peoria","Champaign","Waukegan"
      ],
      Indiana: [
        "Indianapolis","Fort Wayne","Evansville","South Bend","Carmel","Fishers","Bloomington","Hammond","Gary","Lafayette"
      ],
      Iowa: [
        "Des Moines","Cedar Rapids","Davenport","Sioux City","Iowa City","Waterloo","Ames","West Des Moines","Ankeny","Council Bluffs"
      ],
      Kansas: [
        "Wichita","Overland Park","Kansas City","Olathe","Topeka","Lawrence","Shawnee","Manhattan","Lenexa","Salina"
      ],
      Kentucky: [
        "Louisville","Lexington","Bowling Green","Owensboro","Covington","Richmond","Georgetown","Florence","Hopkinsville","Frankfort"
      ],
      Louisiana: [
        "New Orleans","Baton Rouge","Shreveport","Lafayette","Lake Charles","Kenner","Bossier City","Monroe","Alexandria","Houma"
      ],
      Maine: [
        "Portland","Lewiston","Bangor","South Portland","Auburn","Biddeford","Sanford","Saco","Augusta","Brunswick"
      ],
      Maryland: [
        "Baltimore","Frederick","Rockville","Gaithersburg","Bowie","Hagerstown","Annapolis","College Park","Salisbury","Laurel"
      ],
      Massachusetts: [
        "Boston","Worcester","Springfield","Cambridge","Lowell","Brockton","Quincy","Lynn","New Bedford","Fall River"
      ],
      Michigan: [
        "Detroit","Grand Rapids","Warren","Sterling Heights","Ann Arbor","Lansing","Flint","Dearborn","Livonia","Westland"
      ],
      Minnesota: [
        "Minneapolis","Saint Paul","Rochester","Duluth","Bloomington","Brooklyn Park","Plymouth","Woodbury","Maple Grove","St. Cloud"
      ],
      Mississippi: [
        "Jackson","Gulfport","Southaven","Hattiesburg","Biloxi","Meridian","Tupelo","Olive Branch","Greenville","Horn Lake"
      ],
      Missouri: [
        "Kansas City","St. Louis","Springfield","Columbia","Independence","Lee’s Summit","O’Fallon","St. Joseph","St. Charles","Joplin"
      ],
      Montana: [
        "Billings","Missoula","Great Falls","Bozeman","Butte","Helena","Kalispell","Havre","Anaconda","Miles City"
      ],
      Nebraska: [
        "Omaha","Lincoln","Bellevue","Grand Island","Kearney","Fremont","Hastings","Norfolk","Columbus","Papillion"
      ],
      Nevada: [
        "Las Vegas","Henderson","Reno","North Las Vegas","Sparks","Carson City","Elko","Mesquite","Boulder City","Pahrump"
      ],
      New_Hampshire: [
        "Manchester","Nashua","Concord","Derry","Dover","Rochester","Salem","Merrimack","Londonderry","Keene"
      ],
      New_Jersey: [
        "Newark","Jersey City","Paterson","Elizabeth","Edison","Woodbridge","Lakewood","Toms River","Hamilton","Trenton"
      ],
      New_Mexico: [
        "Albuquerque","Las Cruces","Rio Rancho","Santa Fe","Roswell","Farmington","Clovis","Hobbs","Alamogordo","Carlsbad"
      ],
      New_York: [
        "New York City","Buffalo","Rochester","Yonkers","Syracuse","Albany","New Rochelle","Mount Vernon","Schenectady","Utica"
      ],
      North_Carolina: [
        "Charlotte","Raleigh","Greensboro","Durham","Winston-Salem","Fayetteville","Cary","Wilmington","High Point","Concord"
      ],
      North_Dakota: [
        "Fargo","Bismarck","Grand Forks","Minot","West Fargo","Williston","Dickinson","Jamestown","Mandan","Wahpeton"
      ],
      Ohio: [
        "Columbus","Cleveland","Cincinnati","Toledo","Akron","Dayton","Parma","Canton","Youngstown","Lorain"
      ],
      Oklahoma: [
        "Oklahoma City","Tulsa","Norman","Broken Arrow","Edmond","Lawton","Moore","Midwest City","Enid","Stillwater"
      ],
      Oregon: [
        "Portland","Eugene","Salem","Gresham","Hillsboro","Beaverton","Bend","Medford","Springfield","Corvallis"
      ],
      Pennsylvania: [
        "Philadelphia","Pittsburgh","Allentown","Erie","Reading","Scranton","Bethlehem","Lancaster","Harrisburg","York"
      ],
      Rhode_Island: [
        "Providence","Warwick","Cranston","Pawtucket","East Providence","Woonsocket","Coventry","Cumberland","Johnston","North Kingstown"
      ],
      South_Carolina: [
        "Columbia","Charleston","North Charleston","Mount Pleasant","Rock Hill","Greenville","Summerville","Goose Creek","Hilton Head Island","Spartanburg"
      ],
      South_Dakota: [
        "Sioux Falls","Rapid City","Aberdeen","Brookings","Watertown","Mitchell","Yankton","Pierre","Vermillion","Spearfish"
      ],
      Tennessee: [
        "Nashville","Memphis","Knoxville","Chattanooga","Clarksville","Murfreesboro","Franklin","Jackson","Johnson City","Bartlett"
      ],
      Texas: [
        "Houston","San Antonio","Dallas","Austin","Fort Worth","El Paso","Arlington","Corpus Christi","Plano","Lubbock",
        "Irving","Garland","Frisco","McKinney","Amarillo","Grand Prairie","Brownsville","Killeen","Pasadena","Mesquite"
      ],
      Utah: [
        "Salt Lake City","West Valley City","Provo","West Jordan","Orem","Sandy","Ogden","St. George","Layton","South Jordan"
      ],
      Vermont: [
        "Burlington","South Burlington","Rutland","Barre","Montpelier","Winooski","St. Albans","Newport","Bennington","Brattleboro"
      ],
      Virginia: [
        "Virginia Beach","Norfolk","Chesapeake","Richmond","Newport News","Alexandria","Hampton","Roanoke","Portsmouth","Suffolk"
      ],
      Washington: [
        "Seattle","Spokane","Tacoma","Vancouver","Bellevue","Kent","Everett","Renton","Spokane Valley","Federal Way"
      ],
      West_Virginia: [
        "Charleston","Huntington","Morgantown","Parkersburg","Wheeling","Weirton","Fairmont","Beckley","Martinsburg","Clarksburg"
      ],
      Wisconsin: [
        "Milwaukee","Madison","Green Bay","Kenosha","Racine","Appleton","Waukesha","Eau Claire","Oshkosh","Janesville"
      ],
      Wyoming: [
        "Cheyenne","Casper","Gillette","Laramie","Rock Springs","Sheridan","Green River","Evanston","Riverton","Cody"
      ],
    },
  };
  